export var ProfilingLoaders;
(function (ProfilingLoaders) {
    ProfilingLoaders["userIsRetrievingProfile"] = "userIsRetrievingProfile";
    ProfilingLoaders["updatingUserProfile"] = "updatingUserProfile";
    ProfilingLoaders["updatingCompany"] = "updatingCompany";
    ProfilingLoaders["fetchCompany"] = "fetchCompany";
    ProfilingLoaders["fetchApps"] = "fetchApps";
    ProfilingLoaders["fetchTenantsSettings"] = "fetchTenantsSettings";
    ProfilingLoaders["fetchPermissions"] = "fetchPermissions";
    ProfilingLoaders["addUser"] = "addUser";
})(ProfilingLoaders || (ProfilingLoaders = {}));
export const REGIONAL_SETTINGS = [
    { label: 'Metric', value: 'international' },
    { label: 'Imperial', value: 'uk' },
    { label: 'Standard (US)', value: 'us' },
];
export const ROLES = ['Admin', 'Standard'];
export var ProfilingForms;
(function (ProfilingForms) {
    ProfilingForms["editCompany"] = "editCompany";
    ProfilingForms["editUserProfile"] = "editUserProfile";
})(ProfilingForms || (ProfilingForms = {}));
//# sourceMappingURL=constants.js.map